/**
 * resources-video-lightbox.js
 *
 * Makes the "How-To Videos" cards on the Resources & Learning page pop the
 * YouTube video into a lightbox instead of opening a new tab.
 *
 * Reuses the theme's existing <dialog-component> (assets/dialog.js) rather
 * than a separate lightbox library — sections/resource-cards.liquid renders
 * one shared `.resources-video-lightbox-wrapper` dialog per section instance
 * containing a single empty <iframe>. On click of a `.js-video-lightbox-trigger`
 * thumbnail link, this script:
 *   1. Prevents the default navigation (the href stays as a graceful
 *      fallback if JS fails to load, or for middle-click/"open in new tab").
 *   2. Sets the shared iframe's src to the clicked video's YouTube embed URL.
 *   3. Calls the dialog-component's own showDialog() to open it.
 * On close (dialog:close, dispatched by DialogComponent), the iframe src is
 * cleared so the video stops playing in the background.
 */
(function () {
  'use strict';

  function ready(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  function stopPlayback(lightbox) {
    var iframe = lightbox.querySelector('.resources-video-lightbox-iframe');
    if (iframe) iframe.src = '';
  }

  ready(function () {
    var lightboxes = document.querySelectorAll('.resources-video-lightbox-wrapper');
    if (!lightboxes.length) return;

    lightboxes.forEach(function (lightbox) {
      lightbox.addEventListener('dialog:close', function () {
        stopPlayback(lightbox);
      });

      // Defensive fallback in case the <dialog> closes without the
      // dialog:close event firing (e.g. native form/ESC edge cases).
      var dialogEl = lightbox.querySelector('dialog');
      if (dialogEl) {
        dialogEl.addEventListener('close', function () {
          stopPlayback(lightbox);
        });
      }
    });

    document.addEventListener('click', function (event) {
      var trigger = event.target.closest('.js-video-lightbox-trigger');
      if (!trigger) return;

      var card = trigger.closest('[data-video-id]');
      var videoId = card ? (card.getAttribute('data-video-id') || '').trim() : '';
      if (!videoId) return; // No parsed ID — let the link fall back to youtube.com.

      var scope = trigger.closest('.resources-listing-section') || document;
      var lightbox = scope.querySelector('.resources-video-lightbox-wrapper');
      if (!lightbox || typeof lightbox.showDialog !== 'function') return;

      event.preventDefault();

      var iframe = lightbox.querySelector('.resources-video-lightbox-iframe');
      var heading = lightbox.querySelector('h2[id^="resources-video-lightbox-heading-"]');

      if (iframe) {
        iframe.src =
          'https://www.youtube-nocookie.com/embed/' + encodeURIComponent(videoId) + '?autoplay=1&rel=0';
      }
      if (heading) {
        heading.textContent = card.getAttribute('data-title') || 'Video player';
      }

      lightbox.showDialog();
    });
  });
})();
